import { render, staticRenderFns } from "./editCubeV2Input.vue?vue&type=template&id=104f3c62&scoped=true&"
import script from "./editCubeV2Input.vue?vue&type=script&lang=js&"
export * from "./editCubeV2Input.vue?vue&type=script&lang=js&"
import style0 from "./editCubeV2Input.vue?vue&type=style&index=0&id=104f3c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f3c62",
  null
  
)

export default component.exports